import React, { useState } from "react";

import { IAnswerRequest, IMessage } from "app/api/types";

import "./styles.scss";
interface IProps {
  message: IMessage;
  isActive: boolean;
  onSubmit: (data: IAnswerRequest) => void;
}

const EditMessageForm: React.FC<IProps> = (props) => {
  const [answer, setAnswer] = useState(
    props.message.answer ? props.message.answer : ""
  );

  const handleChange = (e: any) => {
    e.target.name === "answer" && setAnswer(e.target.value);
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (answer.length > 2)
      props.onSubmit({
        answer,
        id: props.message.id,
      });
  };

  return (
    <form
      className={`edit-phrase__form ${props.isActive ? "active" : ""}`}
      onSubmit={handleSubmit}
    >
      <label htmlFor="message" className="edit-phrase__label">
        сообщение
      </label>
      <div id="message">{props.message.message}</div>

      <label htmlFor="answer" className="edit-phrase__label">
        ответ
      </label>
      <textarea
        className={`edit-phrase__input`}
        placeholder="введите ответ"
        name="answer"
        value={answer}
        onChange={handleChange}
      />

      <button className="edit-phrase__submit">ответить</button>
    </form>
  );
};

export default EditMessageForm;
